<template>
    <v-layout row xs12 >
        <Loading :value="loading" ></Loading>
        <v-dialog
                v-model="dialogAjoutBudget"
                max-width="70%">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>Ajouter des fournisseurs </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="closeDialog()">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <v-layout row>
                        <v-flex>
                            <data-tables :data="listeTypeTravaux" style="width: 100%">
                                <el-table-column prop="raison" label="RAISON" width="300">                                  
                                </el-table-column>
                                <el-table-column prop="codePartenaire" label="CODE PARTENAIRE" width="300">
                                </el-table-column>
                                <el-table-column prop="formJuridique" label="FORME JURIDIQUE" width="300">                        
                                </el-table-column>
                                <el-table-column prop="registre" label="REGISTE" width="300">                                  
                                </el-table-column>
                                <el-table-column prop="civilite" label="CIVILITE" width="300">                                 
                                </el-table-column>
                                <el-table-column prop="service" label="SERVICE" width="300">                                   
                                </el-table-column>
                                <el-table-column prop="profession" label="PROFESSION" width="300">                               
                                </el-table-column>
                                <el-table-column prop="siege" label="SIEGE" width="300">                                  
                                </el-table-column>
                                <el-table-column prop="nom" label="NOM" width="300">                                 
                                </el-table-column>
                                <el-table-column prop="prenom" label="PRENOM" width="300">                                 
                                </el-table-column>
                                <el-table-column prop="dateNais" label="DATE DE NAISSANCE " width="300">                                
                                </el-table-column>
                                <el-table-column prop="contact" label="CONTACT" width="300">                                 
                                </el-table-column>
                                 <el-table-column prop="numPiece" label="NUMERO DE PIECE" width="300">                               
                                </el-table-column>
                                 <el-table-column prop="naturePiece" label="NATURE DE PIECE" width="300">                               
                                </el-table-column>
                                 <el-table-column prop="typeFour" label="TYPE DE FOURNISSEUR" width="300">                                
                                </el-table-column>
                            </data-tables>
                        </v-flex>
                    </v-layout>


                <!-- <div class="text-xs-right"> -->

                    <v-layout row class="text-xs-right">
                        <v-flex xs2>
                            <!-- <v-tooltip top> -->
                                <v-btn @click="closeDialog()"  slot="activator" icons block color="orange" dark>Anuller <v-icon right>remove_circle</v-icon></v-btn>
                                <!-- <v-btn slot="activator" icons block  @click="closeDialog()" dark>Anuller <v-icon right>remove_circle</v-icon></v-btn> -->
                                <!-- <span>Annuler</span> -->
                            <!-- </v-tooltip> -->
                        </v-flex>

                        <v-flex xs2>
                            <!-- <v-tooltip top> -->
                                <v-btn slot="activator" icons block color="green" @click="saveListe()" dark>Enregistrer <v-icon right>save</v-icon></v-btn>
                                <!-- <span>Enregistrer les produits</span>
                            </v-tooltip> -->
                        </v-flex>

                    </v-layout>
                    <!-- </div> -->

                </v-card-text>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>
    import Loading from '@/components/Loading';
    export default {
        name: "LoadTarifFournExcel",
        components: {Loading},
        props:{
            listeTypeTravaux:
            {
                type: Array,
                default: null,
            },
            show:{
                type: Boolean,
                default: false
            },
            idFour:{
                type: Number,
            }
        },
        data(){
            return {
                domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
                user: JSON.parse(sessionStorage.getItem('userInfo')),
                roleAcces: JSON.parse(sessionStorage.getItem('sessionAcces')),
                droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),
                dialogAjoutBudget: false,
                loading: false
            }
        },
        watch:{
            show: function(newValue,oldValue){
                if(newValue == true){
                    this.dialogAjoutBudget =true;
                }else{
                    this.dialogAjoutBudget =false;
                    // this.loadProduitFounRecent()
                    this.$emit("close");
                }

            }
        },
        methods: {
            saveListe(){
                // this.loadPage()
                 this.loading = true
                let succesEnreg = true;
                let url = this.domaine + "fournisseur/save/fournisseur/liste_Produit/excel";
                let nbData = 10;
                let nbReq = 1;
                let ligne = null;

                let nbRest
                if (this.listeTypeTravaux.length > 10) {
                  nbData = 10;
                  nbReq = Math.round(this.listeTypeTravaux.length / nbData);
                  nbRest = this.listeTypeTravaux.length % nbData;
                  if (nbRest > 0) {
                    nbReq += 1;
                  }
                }
                for(let i=0; i<nbReq;i++)
                {
                    let initJ = i*nbData;
                    let finJ = (i + 1) * nbData;
                    let dataLot = [];
                    if(this.listeTypeTravaux.length > 0){
                        for(let j = initJ;j < finJ;j++){
                            if(this.listeTypeTravaux[j] == undefined){
                                break ;
                            }
                            dataLot.push(this.listeTypeTravaux[j]);
                        }
                    }
                    let data = new FormData();
                    for (let prop in dataLot) {
                        ligne = dataLot[prop];
                        data.append("option[raison][]", ligne.raison);
                        data.append("option[codePartenaire][]", ligne.codePartenaire);
                        data.append("option[formJuridique][]", ligne.formJuridique);
                        data.append("option[registre][]", ligne.registre);
                        data.append("option[typeFour][]", ligne.typeFour);
                        data.append("option[corpsMetier][]", ligne.corpsMetier);
                        data.append("option[civilite][]", ligne.civilite);
                        data.append("option[nom][]", ligne.nom);
                        data.append("option[prenom][]", ligne.prenom);
                        data.append("option[contact][]", ligne.contact);
                        data.append("option[dateNais][]", ligne.dateNais);
                        data.append("option[naturePiece][]", ligne.naturePiece);
                        data.append("option[numPiece][]", ligne.numPiece);
                        data.append("option[siege][]", ligne.siege);
                        data.append("option[profession][]", ligne.profession);
                        data.append("option[contact][]", ligne.contact);
                        data.append("option[service][]", ligne.service);
                      }

                    // data.append('listeTypeTravaux', JSON.stringify(dataLot))
                    data.append('idUser', this.user.id)
                    data.append('fournisseur', this.idFour)


                    this.$http.post(url, data).then(
                        resp => {
                        this.loading = false
                            succesEnreg = false
                        // this.loadProduitFounRecent()

                             this.$emit("close");
                          this.dialogAjoutBudget = false
                           this.$notify({
                            title: "Enregistrement",
                            message: "La liste a ete enregistre avec succes",
                            type: "success",
                            position: "top-right",
                            duration: 7000
                        });
                        },
                        error => {
                            this.loading = false;
                            succesEnreg = false
                          this.dialogAjoutBudget = false
                            this.$message.error(
                                "Erreur lors de l'enregistrement des tarifs"
                            );


                        }
                    )
                }

                //  this.loading = true
                // const loading = this.$loading({
                //     lock: true,
                //     text: 'Veuillez patientez ...',
                //     spinner: 'el-icon-loading',
                //     background: 'rgba(0, 0, 0, 0.7)'
                // })
            },
             loadProduitFounRecent(){
                this.loading = true
                let url=""
                if (this.droitAcces.index_produit_fourn) {
                    url = this.domaine + 'fournisseur/' + this.idFour + '/index/produit/recent'
                } else{
                    url = this.domaine + 'fournisseur/' + this.idFour + '/index/' + this.user.id + '/produit/recent'
                }

                this.$http.get(url).then(response => {
                    if (response.body) {
                        this.loading = false
                    }
                })
            },
             closeDialog() {
                this.$emit("close");
                // this.loadListeTravaux()
            },

        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/tierce/LoadFourn.vue